// removed by extract-text-webpack-plugin
module.exports = {"Item":"_2ytXJ","Bullet":"_22_Ze"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payment/Common/CommonList/CommonListItem/CommonListItem.scss
// module id = 648
// module chunks = 0